export default "__VITE_ASSET__5510c5c9__"